import React from "react";

const UnitKerjaOperator = React.lazy(() => import('./UnitKerjaOperator'))
const Masterdata = React.lazy(() => import('./Masterdata'))

export const masterdataConfigs = [
    //operator
    {
        path: '/masterdata/update-unit-kerja',
        element: <UnitKerjaOperator />,
        permittedRole: ['Operator Eselon 1', 'Operator']
    },

    //administrator
    {
        path: '/masterdata',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    //pendidikan
    {
        path: '/masterdata/pendidikan/pendidikan-terakhir',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/pendidikan/jurusan',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/pendidikan/tingkat-pendidikan',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/pendidikan/sekolah-sd',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/pendidikan/sekolah-smp',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/pendidikan/sekolah-sma',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/pendidikan/universitas',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/pendidikan/program-studi',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/alamat/provinsi',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/jenis-cuti',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/alamat/kelurahan',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/alamat/kecamatan',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/unit-kerja',
        element: <Masterdata />,
        permittedRole: ['Administrator', 'Operator Eselon 1', 'Operator']
    },
    {
        path: '/masterdata/jabatan',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/pp-pelanggaran',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/bahasa',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/hari-libur',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/jam-kerja',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/jadwal-kerja',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/diklat-jabatan',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/kedudukan',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/alamat/negara',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/alamat/kota',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
    {
        path: '/masterdata/tim-kerja',
        element: <Masterdata />,
        permittedRole: ['Administrator']
    },
]